'use strict';

/**
 * @name storage
 */

exports.getItem = require('./get-item.js');
exports.setItem = require('./set-item.js');
exports.removeItem = require('./remove-item.js');
exports.setResult = require('./set-result.js');
